export const getNotifications = ({ page = 1, limit = 20 } = {}) => {
  return fetch(`/shared/api/notifications?page=${page}&limit=${limit}`)
    .then((response) => response.json());
};

export const getUnreadCount = () => {
  return fetch(`/shared/api/unread-count`).then((response) => response.json());
};

export const markNotificationRead = (user_notification_id, body = {}) => {
  return fetch(`/shared/api/markRead?user_notification_id=${user_notification_id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then((response) => response.json());
};

export const clearAllNotifications = (body = {}) => {
  return fetch(`/shared/api/clear-all`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then((response) => response.json());
};

export const clearNotification = (notification_id, body = {}) => {
  return fetch(`/shared/api/clear?notification_id=${notification_id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then((response) => response.json());
};
